import { PermissionObject } from '@eadsysteme/ewsauthclient-v1';
import { RoleType, UiRoleType } from '../services/RoleModel';
import PermissionTypeEnum = PermissionObject.PermissionTypeEnum;

/**
 * Rolle → Auth-`PermissionType`: die einzige Stelle, an der die beiden Wertelisten umgerechnet werden.
 *
 * Die Rollen-Ansicht arbeitet ausschließlich mit `RoleType` — der `PermissionType` gehört an die Grenze zum
 * Auth-Service und ist ansonsten Sache des Reiters „Verantwortliche" (der wiederum `ContactPermission`
 * nutzt). Deshalb tauchen `PROPERTY_MANAGEMENT` und `SERVICE_PROVIDER` hier bewusst nicht auf.
 *
 * Einen Portal-Zugang können nur Eigentümer, Bewohner und Mieter bekommen. uVI-Empfänger und Leerstand
 * nie — die liefern `null`, damit die Oberfläche „nicht möglich" anzeigen kann, statt einen Code
 * anzubieten, den es nicht geben darf.
 */
const PERMISSION_TYPE_BY_ROLE: Partial<Record<RoleType, PermissionTypeEnum>> = {
	[UiRoleType.OWNER]: PermissionTypeEnum.OWNER,
	[UiRoleType.RESIDENT]: PermissionTypeEnum.RESIDENT,
	[UiRoleType.TENANT]: PermissionTypeEnum.TENANT,
};

export function permissionTypeForRole(roleType: RoleType | null | undefined): PermissionTypeEnum | null {
	return (roleType && PERMISSION_TYPE_BY_ROLE[roleType]) || null;
}

/** Kann diese Rolle überhaupt einen araWeb-/araApp-Zugang haben? */
export function canHavePortalAccess(roleType: RoleType | null | undefined): boolean {
	return permissionTypeForRole(roleType) !== null;
}
